/* Elle.ay personalisation fields (blocks/ea-personalise.liquid). */
(() => {
  const init = (root) => {
    if (root.dataset.eaReady) return;
    root.dataset.eaReady = '1';
    const box = root.querySelector('.ea-p__box');
    const want = (root.dataset.onlyWhen || '').toLowerCase();
    const name = root.querySelector('input[type="text"]');
    const scope = root.closest('.shopify-section') || document;

    // Live character count and preview of the text to be made.
    if (name) {
      const count = root.querySelector('[data-ea-count]');
      const preview = root.querySelector('[data-ea-preview]');
      name.addEventListener('input', () => { count.textContent = name.value.length; preview.textContent = name.value; });
    }
    if (!box || !want) return;

    // Show the fields only while the chosen option matches (e.g. "Personalised"); otherwise hide them
    // and switch the inputs off so nothing extra is sent with the order.
    const sync = () => {
      const chosen = [...scope.querySelectorAll('variant-picker input:checked, variant-picker select')]
        .map((el) => (el.value || '').toLowerCase());
      const on = chosen.some((v) => v.includes(want));
      box.hidden = !on;
      root.querySelectorAll('[data-ea-personal]').forEach((el) => { el.hidden = !on; });
      box.querySelectorAll('input, textarea').forEach((el) => { el.disabled = !on; });
      if (name) name.required = on;
    };
    scope.addEventListener('change', (e) => { if (e.target.closest('variant-picker')) requestAnimationFrame(sync); });
    document.addEventListener('variant:update', () => requestAnimationFrame(sync));
    sync();
  };
  const run = () => document.querySelectorAll('.ea-p').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
